import React from 'react';
import { Row, Col } from 'reactstrap';
import CustomCard from '../CustomCard';
import CardHeader from '../CustomCard/CardHeader';
import CardBody from '../CustomCard/CardBody';
import { renderHTMLContent } from '../../../common/function';

function ShowAnswer(props) {
  const { correct_choice: correctChoice, explanation, attemptedQuesObject, id } = props;
  return (
    <Row>
      <Col>
        <CustomCard className='font-lusitana font-16px'>
          <CardHeader
            headingText={
              attemptedQuesObject[id] === correctChoice
                ? 'Correct'
                : attemptedQuesObject[id] !== undefined
                  ? 'Incorrect'
                  : 'Not Attempted'
            }
            headerImage=''
            className={`text-uppercase ${attemptedQuesObject[id] === correctChoice
              ? 'text_success'
              : attemptedQuesObject[id] !== undefined
                ? 'text_failure'
                : ''
              }
            }`}
          />
          <CardBody>
            {renderHTMLContent(explanation, "span")}
          </CardBody>
        </CustomCard>
      </Col>
    </Row>
  );
}

export default ShowAnswer;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ShowAnswer.jsx